import React from 'react';
import { QuickFilterContainer } from '@tanium/react-quick-filters';
import { Stack } from '@tanium/react-stack';
import { Id } from '../../types/Id';
import {
  RibbonListResultsHeaderProps,
  StackedRibbonListOnlyProps,
} from '../../types/StackedRibbonListComponentTypes';
import { StackedRibbonListWrapper } from '../StackedRibbonList/StackedRibbonListWrapper';
import { RibbonListResultsHeader } from './RibbonListResultsHeader';

export interface HeaderWrapperProps<TId extends Id, TItem>
  extends RibbonListResultsHeaderProps<TId, TItem>,
    StackedRibbonListOnlyProps<TId, TItem> {
  children: React.ReactNode;
}

/**
 * A wrapper component to be used around a StackedRibbonList component, providing the
 * RibbonListResultsHeader and list container.
 */
export const ResultsHeaderWrapper = <TId extends Id, TItem>({
  listActionsPlacement,
  advancedFilters,
  children,
  defaultFilterText,
  filterPlaceholder,
  filterText,
  itemCount,
  itemsLabel,
  listActions,
  onFilterTextChange,
  quickFilters,
  rowActions,
  selectedWellBg,
  selection,
  selectionMode,
  totalItemCount,
  width,
}: HeaderWrapperProps<TId, TItem>) => (
  <Stack width={width} direction="column" itemSpacing={1 / 2}>
    <RibbonListResultsHeader
      listActionsPlacement={listActionsPlacement}
      defaultFilterText={defaultFilterText}
      filterPlaceholder={filterPlaceholder}
      filterText={filterText}
      itemCount={itemCount}
      itemsLabel={itemsLabel}
      listActions={listActions}
      onFilterTextChange={onFilterTextChange}
      rowActions={rowActions}
      selectedWellBg={selectedWellBg}
      selection={selection}
      selectionMode={selectionMode}
      totalItemCount={totalItemCount}
    />
    {quickFilters && (
      <div>
        <QuickFilterContainer>{quickFilters}</QuickFilterContainer>
      </div>
    )}
    <div>
      {advancedFilters && <>{advancedFilters}</>}
      <StackedRibbonListWrapper hasAdvancedFilter={!!advancedFilters}>
        {children}
      </StackedRibbonListWrapper>
    </div>
  </Stack>
);
